import React, { useState } from 'react';
import { motion } from 'framer-motion';
import MenuCard from '../components/MenuCard';
import CategoryFilter from '../components/CategoryFilter';
import { usePocketBaseRealtime } from '../hooks/usePocketBaseRealtime';
import { useRestaurantBrand } from '../hooks/useRestaurantBrand';

const MenuCliente = () => {
  const brand = useRestaurantBrand();
  const { data: menuData = [], loading, error } = usePocketBaseRealtime('menu');
  const [selectedCategory, setSelectedCategory] = useState('tutte');

  // 1. Filtriamo IMMEDIATAMENTE solo i piatti disponibili per il cliente
  const availableMenu = menuData.filter(piatto => piatto.disponibile === true);

  // 2. Otteniamo le categorie solo dai piatti effettivamente disponibili
  const categories = [...new Set(availableMenu.map(piatto => piatto.categoria))];

  // 3. Ordiniamo i piatti disponibili
  const sortedMenu = [...availableMenu].sort((a, b) => {
    if (a.categoria_ordine !== b.categoria_ordine) {
      return (a.categoria_ordine || 0) - (b.categoria_ordine || 0);
    }
    return a.nome.localeCompare(b.nome);
  });

  // 4. Applichiamo il filtro per categoria
  const filteredMenu = selectedCategory === 'tutte' 
    ? sortedMenu 
    : sortedMenu.filter(piatto => piatto.categoria === selectedCategory);

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#5C715E]"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-red-800 mb-2">Errore di connessione</h3>
          <p className="text-red-600">Impossibile caricare il menù. Errore: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="max-w-7xl mx-auto px-4 py-8">
      <div className="text-center mb-8">
        <h1 className="text-3xl md:text-5xl font-black text-gray-900 mb-3 tracking-tight">
          Menù {brand.nome}
        </h1>
        <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
          {brand.sottotitolo || 'Scopri i nostri piatti freschi e preparati con ingredienti di qualità'}
        </p>
      </div>

      {categories.length > 0 && (
        <CategoryFilter 
          categories={categories} 
          selectedCategory={selectedCategory} 
          onCategoryChange={setSelectedCategory} 
        />
      )}

      {filteredMenu.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500 text-lg">
            Nessun piatto disponibile al momento in questa sezione.
          </p>
        </div>
      ) : (
        <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredMenu.map((piatto) => (
            <MenuCard key={piatto.id} piatto={piatto} />
          ))}
        </motion.div>
      )}
    </motion.div>
  );
};

export default MenuCliente;